// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sync-progress__stat[data-v-7f46fe0f]{color:#333;margin:20px auto 30px}.sync-progress__stat--calculating[data-v-7f46fe0f]{-webkit-animation:blink-data-v-7f46fe0f 2s linear infinite;animation:blink-data-v-7f46fe0f 2s linear infinite}.sync-progress__img[data-v-7f46fe0f]{margin:30px auto 0}@-webkit-keyframes blink-data-v-7f46fe0f{50%{opacity:.2}}@keyframes blink-data-v-7f46fe0f{50%{opacity:.2}}", ""]);
// Exports
module.exports = exports;
